import React from 'react';
import { useEffect, useState } from 'react';
import './App.css';
import Emulator from './Emulator';
import Home from './Home';

const App = () => {
  const [rom, setRom] = React.useState(null);
  return (
    <div className="App">
      {!rom ?
        <Home rom={rom} setRom={setRom} /> :
        <Emulator rom={rom} setRom={setRom} />
      }
    </div>
  )
}

export default App;
